import { Injectable, inject } from "@angular/core";
import { delay, filter, switchMap, throttleTime } from "rxjs/operators";
import { EMPTY, combineLatest } from "rxjs";
import { TradableWalletListService } from "@main-services/wallet/tradable_wallet_list.service";
import { CashPlusFacade } from "./cashplus.facade";
import { FiatWalletService } from "@main-services/wallet/fiat_wallet.service";

@Injectable({ providedIn: "root" })
export class CashplusUpdateService {
	private cashPlusFacade = inject(CashPlusFacade);
	private tradableWalletListService = inject(TradableWalletListService);
	private fiatwalletService = inject(FiatWalletService);

	public initCashplusPortfolioUpdates(): void {
		// Emits on new trades/deposits or anything that changes tradable wallets state
		const tw$ = this.tradableWalletListService.getList().pipe(filter((list) => !!list.length));

		// Emits on new trades/deposits or anything that changes fiat wallets state
		const fw$ = this.fiatwalletService.getList().pipe(filter((list) => !!list.length));

		const isCashPlusEnabled$ = this.cashPlusFacade.isCashPlusEnabled$();

		// subscription
		isCashPlusEnabled$
			.pipe(
				switchMap((state) => {
					if (state) {
						return combineLatest([tw$, fw$]).pipe(throttleTime(1000), delay(1000));
					}

					return EMPTY;
				})
			)
			.subscribe({
				next: () => {
					this.cashPlusFacade.fetchPortfolioFiatConfigForAllFiat();
				}
			});
	}
}
